module.exports = __webpack_public_path__ + "static/media/arrow-down_yl.e51de352.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-down_yl.svg
// module id = 380
// module chunks = 0